import React from 'react';
import moment from 'moment';

import {AppContext} from '../../../AppModule/Context';

import NotificationComponent from '../genericComponents/notificationComponent';

import bookingFlowInstanceService from '../../../services/restServices/bookingFlowInstanceService';
import storageService from '../../../services/storageService';
import utilsService from '../../../services/utilsService';
import widgetService from '../../../services/restServices/widgetService';

import VIDABOO_CONSTANTS from '../../../config/consts';

class AutomatedCallAndBFI extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      time: '',
    };
    this.peerStatusNotLoaded = true;
    this.TIME_TO_AUTO_REDIRECT = 10;
  }

  componentDidMount() {
    if (!this.props.isAutomatedCallHandled) {
      // Handle automate the tasks based on query params
      if (
        this.props.startValueFromQuery &&
        this.props.extendedMentorDto.mentorDto.appControlDto.zeroClickCall
      ) {
        this.autoMatedCalls();
      }
      // Handle the booking flow instance token
      if (this.props.bfi) {
        this.handleBookingFlowInstance();
      }
    }
    if (
      this.props.actionClickData?.etClickType === 'start-call' ||
      this.props.actionClickData?.etConsoltoStart ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.VIDEO_CALL
    ) {
      // passing this param to make sure we schedule the timer if peer is not available
      this.props.connectVideoCall(true);
      this.props.setIsAutomatedCallHandled(true);
      this.props.resetActionClickData();
    } else if (
      this.props.actionClickData?.etClickType === 'start-audio-call' ||
      this.props.actionClickData?.etConsoltoStart ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.AUDIO_CALL
    ) {
      if (
        this.props.actionClickData.etClickInitiator ===
        VIDABOO_CONSTANTS.ACTION_CLICK_INITIATOR.FOOTER
      ) {
        this.props.resetActionClickData();
      } else {
        this.props.connectAudioOnlyCall(true);
        this.props.setIsAutomatedCallHandled(true);
        this.props.resetActionClickData();
      }
    }
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.isPersonalPage) {
      // personal page
      // if (
      //   prevProps.postCallFail !== this.props.postCallFail &&
      //   this.props.postCallFail
      // ) {
      //   this.handleOnUpdateOrRestoreState(true);
      // }

      if (
        this.context.peersStatus &&
        this.context.peersStatus[
          this.props.extendedMentorDto.mentorDto.mentorOwnerId
        ] &&
        this.peerStatusNotLoaded
      ) {
        this.peerStatusNotLoaded = false;
        this.props.sendStartChatGA(); // we can start chat only after peer availability was determined. Otherwise, autochat will not work.
        if (
          prevProps.showNotificationPopupForWait !==
            this.props.showNotificationPopupForWait &&
          this.props.showNotificationPopupForWait &&
          !this.props.isWithButton &&
          this.context.peersStatus[
            this.props.extendedMentorDto.mentorDto.mentorOwnerId
          ] !== undefined &&
          this.context.peersStatus[
            this.props.extendedMentorDto.mentorDto.mentorOwnerId
          ] !== VIDABOO_CONSTANTS.AVAILABILITY_STATES.AVAILABLE &&
          this.context.peersStatus[
            this.props.extendedMentorDto.mentorDto.mentorOwnerId
          ] !== VIDABOO_CONSTANTS.AVAILABILITY_STATES.BUSY
        ) {
          this.setNotificationPopuForWebCall(
            true,
            !this.props.bfi
              ? `Waiting for ${
                  this.props.extendedMentorDto.mentorDto.displayName
                } to join.\n${this.getTimerTime()}`
              : `Waiting for ${
                  this.props.extendedMentorDto.mentorDto.displayName
                } to become available. We'll keep trying for another \n${this.getTimerTime()}`,
          );
        } else if (
          this.props.isWithButton &&
          this.context.peersStatus[
            this.props.extendedMentorDto.mentorDto.mentorOwnerId
          ] !== undefined &&
          (this.context.peersStatus[
            this.props.extendedMentorDto.mentorDto.mentorOwnerId
          ] === VIDABOO_CONSTANTS.AVAILABILITY_STATES.AVAILABLE ||
            this.context.peersStatus[
              this.props.extendedMentorDto.mentorDto.mentorOwnerId
            ] === VIDABOO_CONSTANTS.AVAILABILITY_STATES.BUSY)
        ) {
          this.handleOnUpdateOrRestoreState(false);
        }
      }

      // Wait for mentor available only if call is not started with button
      if (
        prevProps.showNotificationPopupForWait !==
          this.props.showNotificationPopupForWait &&
        this.props.showNotificationPopupForWait &&
        !this.props.isWithButton
      ) {
        let msg = '';
        this.startTimer();
        if (
          this.context.peersStatus &&
          this.context.peersStatus[
            this.props.extendedMentorDto.mentorDto.mentorOwnerId
          ] === undefined
        ) {
          msg = 'Igniting the connection engine…';
        } else if (
          this.context.peersStatus[
            this.props.extendedMentorDto.mentorDto.mentorOwnerId
          ] !== VIDABOO_CONSTANTS.AVAILABILITY_STATES.AVAILABLE &&
          this.context.peersStatus[
            this.props.extendedMentorDto.mentorDto.mentorOwnerId
          ] !== VIDABOO_CONSTANTS.AVAILABILITY_STATES.BUSY
        ) {
          msg = !this.props.bfi
            ? `Waiting for ${
                this.props.extendedMentorDto.mentorDto.displayName
              } to join.\n${this.getTimerTime()}`
            : `Waiting for ${
                this.props.extendedMentorDto.mentorDto.displayName
              } to become available. We'll keep trying for another \n${this.getTimerTime()}`;
        }
        this.setNotificationPopuForWebCall(
          this.props.showNotificationPopupForWait,
          msg,
        );
      }

      // if(call started with button then load default popup)
      if (
        prevProps.showNotificationPopupForWait !==
          this.props.showNotificationPopupForWait &&
        this.props.showNotificationPopupForWait &&
        this.props.isWithButton
      ) {
        this.handleOnUpdateOrRestoreState(true);
      }

      // If one(or time as per consts file also as per automate or scheduled call) minute reached or popup cancelled, then we are showing the "leave message and exit"
      if (
        prevProps.showNotificationPopupForWait !==
          this.props.showNotificationPopupForWait &&
        !this.props.showNotificationPopupForWait
      ) {
        this.stopTimer();
        this.handleOnUpdateOrRestoreState(false);
        if (!this.props.isClearedManually) {
          // this.handleOnUpdateOrRestoreState(true);
          if (
            this.context.peersStatus[
              this.props.extendedMentorDto.mentorDto.mentorOwnerId
            ] !== VIDABOO_CONSTANTS.AVAILABILITY_STATES.AVAILABLE &&
            this.context.peersStatus[
              this.props.extendedMentorDto.mentorDto.mentorOwnerId
            ] !== VIDABOO_CONSTANTS.AVAILABILITY_STATES.BUSY
          ) {
            this.props.onFooterOptionSelected(
              VIDABOO_CONSTANTS.WIDGET_APP_TYPES.POST_CALL_FAIL,
            );
          }
        }
        // else {
        //   this.handleOnUpdateOrRestoreState(false);
        // }
      }
    } else {
      // widget
      if (
        prevProps.postCallFail !== this.props.postCallFail &&
        this.props.postCallFail
      ) {
        this.props.onFooterOptionSelected(
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.POST_CALL_FAIL,
        );
      }
      if (
        this.context.peersStatus &&
        this.context.peersStatus[
          this.props.extendedMentorDto.mentorDto.mentorOwnerId
        ]
      ) {
        if (
          prevProps.showNotificationPopupForWait !==
            this.props.showNotificationPopupForWait &&
          this.props.showNotificationPopupForWait &&
          this.context.peersStatus[
            this.props.extendedMentorDto.mentorDto.mentorOwnerId
          ] !== undefined &&
          this.context.peersStatus[
            this.props.extendedMentorDto.mentorDto.mentorOwnerId
          ] !== VIDABOO_CONSTANTS.AVAILABILITY_STATES.AVAILABLE &&
          this.context.peersStatus[
            this.props.extendedMentorDto.mentorDto.mentorOwnerId
          ] !== VIDABOO_CONSTANTS.AVAILABILITY_STATES.BUSY
        ) {
          this.setNotificationPopuForWebCall(
            true,
            !this.props.bfi
              ? `Waiting for ${
                  this.props.extendedMentorDto.mentorDto.displayName
                } to join.\n${this.getTimerTime()}`
              : `Waiting for ${
                  this.props.extendedMentorDto.mentorDto.displayName
                } to become available. We'll keep trying for another \n${this.getTimerTime()}`,
          );
        }
      }

      // Wait for mentor available only if call is not started with button
      if (
        prevProps.showNotificationPopupForWait !==
          this.props.showNotificationPopupForWait &&
        this.props.showNotificationPopupForWait
      ) {
        let msg = '';
        this.startTimer();
        if (
          this.context.peersStatus &&
          this.context.peersStatus[
            this.props.extendedMentorDto.mentorDto.mentorOwnerId
          ] === undefined
        ) {
          msg = 'Igniting the connection engine…';
        } else if (
          this.context.peersStatus[
            this.props.extendedMentorDto.mentorDto.mentorOwnerId
          ] !== VIDABOO_CONSTANTS.AVAILABILITY_STATES.AVAILABLE &&
          this.context.peersStatus[
            this.props.extendedMentorDto.mentorDto.mentorOwnerId
          ] !== VIDABOO_CONSTANTS.AVAILABILITY_STATES.BUSY
        ) {
          msg = !this.props.bfi
            ? `Waiting for ${
                this.props.extendedMentorDto.mentorDto.displayName
              } to join.\n${this.getTimerTime()}`
            : `Waiting for ${
                this.props.extendedMentorDto.mentorDto.displayName
              } to become available. We'll keep trying for another \n${this.getTimerTime()}`;
        }
        this.setNotificationPopuForWebCall(
          this.props.showNotificationPopupForWait,
          msg,
        );
      }

      // If one(or time as per consts file also as per automate or scheduled call) minute reached or popup cancelled, then we are showing the "leave message and exit"
      if (
        prevProps.showNotificationPopupForWait !==
          this.props.showNotificationPopupForWait &&
        !this.props.showNotificationPopupForWait
      ) {
        this.stopTimer();
        this.handleOnUpdateOrRestoreState(false);
        if (!this.props.isClearedManually) {
          this.props.onFooterOptionSelected(
            VIDABOO_CONSTANTS.WIDGET_APP_TYPES.POST_CALL_FAIL,
          );
        }
      }
    }
  };

  componentWillUnmount = () => {
    this.redirectionTimeout && clearTimeout(this.redirectionTimeout);
  };

  checkIfMeetingIsEnded = (bookingFlowInstance) => {
    if (
      bookingFlowInstance.confirmedSessionEndTime - new Date().getTime() <=
      0
    ) {
      return true;
    }
    return false;
  };

  checkIfMeetingIsOverdue = (bookingFlowInstance) => {
    if (
      bookingFlowInstance.confirmedSessionEndTime - new Date().getTime() >
      0
    ) {
      return false;
    }
    return true;
  };

  handleWebCallAfterSessionTimeArrived = (isCallWithButton) => {
    this.props.connectAudioOnlyCall(isCallWithButton);
    // if (utilsService.getIsInWidget()) {
    //   this.props.onFooterOptionSelected(
    //     VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL,
    //   );
    //   if (!this.props.personalPageFrontComponentRef) {
    //     const timerInterval2 = setInterval(() => {
    //       if (this.props.personalPageFrontComponentRef) {
    //         this.props.personalPageFrontComponentRef.startVideoCall(
    //           !isCallWithButton,
    //         );
    //         clearInterval(timerInterval2);
    //       } else {
    //         console.debug(this.props, this.props.getWidgetVideoComponentRef());
    //       }
    //     }, 100);
    //   } else {
    //     this.props.personalPageFrontComponentRef.startVideoCall(
    //       !isCallWithButton,
    //     );
    //   }
    // } else {
    //   //todomcss : fix using windowScreenSize
    //   if (utilsService.isMobileDevice()) {
    //     this.props.onFooterOptionSelected(
    //       VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL,
    //     );
    //     let autocall = setInterval(() => {
    //       if (this.props.getWidgetVideoComponentRef()) {
    //         clearInterval(autocall);
    //         this.props.personalPageFrontComponentRef.connectAudioOnlyCall(
    //           false,
    //         );
    //       }
    //     }, 250);
    //   } else {
    //     this.props.personalPageFrontComponentRef.current.checkToCollectPeerInfo(
    //       VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL,
    //       !!isCallWithButton,
    //     );
    //   }
    // }
  };

  checkIfUserIsMentorOfSession = (mentorOfSessionId) => {
    // Note: when CNAME is deployed, cookies will no longer work. In that case, we'll need to implement a fall-back with postMessage. See https://consolto.atlassian.net/browse/CFW-1054
    const userIdFromCookie = storageService.getCookie(
      VIDABOO_CONSTANTS.LOCAL_STORAGE_ITEMS.CONSOLTO_USER_ID,
    );
    if (mentorOfSessionId && userIdFromCookie === mentorOfSessionId) {
      return true;
    }
    return false;
  };

  openBackoffice = (bookingFlowInstance) => {
    const isInWidget = utilsService.getIsInWidget();
    window.open(
      VIDABOO_CONSTANTS.APP_PAGE +
        '/bfi=' +
        bookingFlowInstance.bookingFlowInstanceId,
      isInWidget ? '_blank' : '_self',
    );
  };

  doWhenWidgetDtoReceived = (response, bookingFlowInstance) => {
    const mentorOfSessionId =
      response.widgetDto.mentorsControlMapDto[bookingFlowInstance.mentorId]
        ?.extendedMentorDto?.mentorDto?.mentorOwnerId;
    const isMentorOfSession =
      this.checkIfUserIsMentorOfSession(mentorOfSessionId);
    if (isMentorOfSession) {
      // redirect to the backoffice
      this.cancelRedirection = false;
      this.redirectionTimeout = setTimeout(() => {
        if (this.cancelRedirection) {
          this.cancelRedirection = false;
          return;
        }

        this.openBackoffice(bookingFlowInstance);
      }, this.TIME_TO_AUTO_REDIRECT * 1000);

      this.setState({
        showNotificationPopup: true,
        notificationText:
          'You are the host. Redirecting to Consolto to accept the call. ',
        popupAcceptBtnText: 'GO',
        popupAcceptBtnFunc: () => {
          // Start video call
          this.openBackoffice(bookingFlowInstance);

          this.closePopups();
        },
        popupCloseBtnText: 'Stay here',
        popupCloseBtnFunc: () => {
          this.cancelRedirection = true;
          this.closePopups();
        },
      });
      console.debug(
        'This is the host of the meeting. Redirecting to backoffice',
      );
    } else {
      const currentTimeInMs = moment().valueOf();
      // IF status is confirmed
      if (
        bookingFlowInstance.status ===
        VIDABOO_CONSTANTS.BOOKING_FLOW_STATES.CONFIRMED
      ) {
        if (bookingFlowInstance.confirmedSessionStartTime > currentTimeInMs) {
          const timeDiff =
            moment(bookingFlowInstance.confirmedSessionStartTime).valueOf() -
            currentTimeInMs;

          let duration = moment.duration(timeDiff, 'milliseconds');
          this.setState({
            notificationText: `Waiting for meeting with ${
              this.props.extendedMentorDto.mentorDto.displayName
            } to start in \n${duration.days()}d:${duration.hours()}h:${duration.minutes()}m:${duration.seconds()}s`,
            showNotificationPopup: true,
            showCloseIcon: false,
          });

          const interval = 1000;

          const timerInterval = setInterval(() => {
            duration = moment.duration(duration - interval, 'milliseconds');
            const notificationText = `Waiting for meeting with ${
              this.props.extendedMentorDto.mentorDto.displayName
            } to start in \n${duration.days()}d:${duration.hours()}h:${duration.minutes()}m:${duration.seconds()}s`;
            this.setState({
              notificationText,
            });
          }, interval);
          const callTimeout = setTimeout(() => {
            clearInterval(timerInterval);
            this.handleOnUpdateOrRestoreState(false);

            // Start video call
            this.handleWebCallAfterSessionTimeArrived();

            this.props.onFooterOptionSelected(
              VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL,
            );
          }, timeDiff);
          this.setState({
            popupCloseBtnFunc: () => {
              clearInterval(timerInterval);
              clearTimeout(callTimeout);
              this.closePopups();
            },
            popupCloseBtnText: 'Cancel',
          });
        } else if (this.checkIfMeetingIsOverdue(bookingFlowInstance)) {
          this.setNotificationPopuForScheduling(
            true,
            'This meeting has passed. Start a call anyway?',
            true,
          );
        } else if (this.checkIfMeetingIsEnded(bookingFlowInstance)) {
          this.setNotificationPopuForScheduling(
            true,
            'Meeting has ended. Start a call anyway?',
            true,
          );
        } else {
          this.handleOnUpdateOrRestoreState(false);
          // Start video call
          this.handleWebCallAfterSessionTimeArrived();
          this.props.onFooterOptionSelected(
            VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL,
          );
        }
      } else if (
        bookingFlowInstance.status ===
        VIDABOO_CONSTANTS.BOOKING_FLOW_STATES.CREATED
      ) {
        this.setNotificationPopuForScheduling(
          true,
          'This scheduled meeting has not been accepted yet. Start a call anyway?',
        );
      } else if (
        bookingFlowInstance.status ===
        VIDABOO_CONSTANTS.BOOKING_FLOW_STATES.OVERDUE
      ) {
        this.setNotificationPopuForScheduling(
          true,
          'This meeting has passed. Start a call anyway?',
          true,
        );
      } else if (
        bookingFlowInstance.status ===
          VIDABOO_CONSTANTS.BOOKING_FLOW_STATES.CANCELLED ||
        bookingFlowInstance.status ===
          VIDABOO_CONSTANTS.BOOKING_FLOW_STATES.DECLINED
      ) {
        this.setNotificationPopuForScheduling(
          true,
          `Meeting has ${
            bookingFlowInstance.status ===
            VIDABOO_CONSTANTS.BOOKING_FLOW_STATES.CANCELLED
              ? 'cancelled'
              : 'declined'
          }. Start a call anyway?`,
        );
      } else if (
        bookingFlowInstance.status ===
        VIDABOO_CONSTANTS.BOOKING_FLOW_STATES.REBOOKED
      ) {
        this.setNotificationPopuForScheduling(
          true,
          'Meeting has rescheduled. Start a call anyway?',
        );
      }
    }
  };

  handleBookingFlowInstance = () => {
    this.props.setIsAutomatedCallHandled(true);
    bookingFlowInstanceService.getBookingFlowInstanceByBookingFlowInstanceId(
      this.props.bfi,
      true,
      (response) => {
        const bookingFlowInstance = response.data.bookingFlowInstanceDto;
        if (bookingFlowInstance.sessionTemplateId) {
          widgetService.getWidgetDtoBySessionTemplateId(
            bookingFlowInstance.sessionTemplateId,
            (response) => {
              this.doWhenWidgetDtoReceived(response, bookingFlowInstance);
            },
            (response) => {
              console.debug(
                'Error fetching session template: ' + bookingFlowInstance,
                response,
              );
              this.showBfiErrorPopUp();
            },
          );
        } else {
          console.debug(
            'Missing sessionTemplateId in bfi: ',
            bookingFlowInstance,
          );
          this.showBfiErrorPopUp();
        }
      },
      (error) => {
        console.debug('Error occurred to fetch the booking flow', error);
        this.showBfiErrorPopUp();
      },
      null,
    );
  };

  showBfiErrorPopUp = () => {
    this.setState({
      showNotificationPopup: true,
      notificationText:
        'There was an error while bringing the meeting. Would you like to start the call anyways?',
      popupAcceptBtnFunc: () => {
        this.closePopups();
      },
      popupAcceptBtnText: this.context.languageSet.VIDEO_CALL_CAT.CALL_NOW, // "Call now",
      popupRejectBtnFunc: null,
      popupRejectBtnText: null,
      popupCloseBtnFunc: () => {
        this.closePopups();
        this.props.onFooterOptionSelected(
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT,
        );
        this.props.sendStartChatGA();
      },
      popupCloseBtnText: this.context.languageSet.CONSOLTO_WIDGET.MESSAGE, // "Message",
    });
  };

  autoMatedCalls = () => {
    if (
      this.props.startValueFromQuery ===
      VIDABOO_CONSTANTS.TRIGGER_ACTIONS.VIDEO_CALL
    ) {
      this.props.setIsAutomatedCallHandled(true);
      this.props.connectVideoCall(false);
    } else if (
      this.props.startValueFromQuery ===
      VIDABOO_CONSTANTS.TRIGGER_ACTIONS.AUDIO_CALL
    ) {
      this.props.setIsAutomatedCallHandled(true);
      this.props.connectAudioOnlyCall(false);
    }
  };

  startTimer = () => {
    const startTime = moment().valueOf();
    const timeLimit = this.props.bfi
      ? VIDABOO_CONSTANTS.AUTO_CANCEL_TIME_FOR_SCHEDULED_CALLS
      : VIDABOO_CONSTANTS.AUTO_CANCEL_TIME_FOR_AUTOMATED_CALLS;
    const countdownTime = startTime + timeLimit;
    const timeDiff = moment(countdownTime).valueOf() - startTime;

    let duration = moment.duration(timeDiff, 'milliseconds');
    const interval = 1000;
    const timerInterval = setInterval(() => {
      duration = moment.duration(duration - interval, 'milliseconds');
      this.setState({
        time: `${duration.days()}d:${duration.hours()}h:${duration.minutes()}m: ${duration.seconds()}s`,
      });
      const notificationText = !this.props.bfi
        ? `Waiting for ${
            this.props.extendedMentorDto.mentorDto.displayName
          } to join.\n${this.getTimerTime()}`
        : `Waiting for ${
            this.props.extendedMentorDto.mentorDto.displayName
          } to become available. We'll keep trying for another \n${this.getTimerTime()}`;
      this.setState(
        {
          time: `${duration.days()}d:${duration.hours()}h:${duration.minutes()}m: ${duration.seconds()}s`,
        },
        () => {
          if (
            this.context.peersStatus[
              this.props.extendedMentorDto.mentorDto.mentorOwnerId
            ] !== undefined
          ) {
            this.setState({
              notificationText,
            });
          }
        },
      );
    }, interval);
    this.setState({timerInterval});
  };

  stopTimer = () => {
    clearInterval(this.state.timerInterval);
    this.setState({timerInterval: null, time: 60});
  };

  getTimerTime = () => this.state.time;

  handleOnUpdateOrRestoreState = (
    showNotificationPopup,
    isClickedCancelForWidgetOnly,
  ) => {
    this.setState({
      showNotificationPopup,
      notificationText:
        this.context.languageSet.VIDEO_CALL_CAT.IM_NOT_AVAILABLE +
        ' ' +
        this.context.languageSet.VIDEO_CALL_CAT.LEAVE_MESSAGE +
        ' ' +
        this.context.languageSet.VIDEO_CALL_CAT.OR +
        ' ' +
        this.context.languageSet.VIDEO_CALL_CAT.TRY_AGAIN, //"I'm not available right now. Leave me a message or try again.",
      popupAcceptBtnFunc: () => {
        this.props.onFooterOptionSelected(
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL,
        );
      },
      popupAcceptBtnText: this.context.languageSet.VIDEO_CALL_CAT.TRY_AGAIN, // "Try again",
      popupRejectBtnFunc: null,
      popupRejectBtnText: null,
      popupCloseBtnFunc: () => {
        this.closePopups();
        this.props.onFooterOptionSelected(
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT,
        );
        this.props.sendStartChatGA();
        this.props.clearAutomatedCallLoop();
      },
      popupCloseBtnText: this.context.languageSet.CONSOLTO_WIDGET.MESSAGE, // "Message",
      showCloseIcon: true,
    });
    if (utilsService.getIsInWidget() && isClickedCancelForWidgetOnly) {
      this.props.onFooterOptionSelected(
        VIDABOO_CONSTANTS.WIDGET_APP_TYPES.POST_CALL_FAIL,
      );
    } else {
      this.props.onFooterOptionSelected(
        VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT,
      );
    }
  };

  closePopups = () => {
    this.setState({
      showNotificationPopup: false,
      showNotificationPopupForWait: false,
    });
    this.props.clearAutomatedCallLoop();
  };

  setNotificationPopuForScheduling(show, message, isMeetingEnded) {
    this.setState({
      showNotificationPopup: show,
      notificationText: message,
      popupAcceptBtnText: 'Start Call',
      popupAcceptBtnFunc: () => {
        // Start video call
        this.handleWebCallAfterSessionTimeArrived(true);

        this.closePopups();
      },
      popupCloseBtnText: isMeetingEnded ? 'Message' : 'Cancel',
      popupCloseBtnFunc: isMeetingEnded
        ? () => {
            this.props.onFooterOptionSelected(
              VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT,
            );
            this.closePopups();
          }
        : this.closePopups,
    });
  }

  setNotificationPopuForWebCall(show, message) {
    this.setState({
      notificationText: message,
      showNotificationPopup: show,
      popupAcceptBtnFunc: null,
      popupRejectBtnFunc: null,
      popupCloseBtnFunc: () => {
        this.setState({
          showNotificationPopupForWait: false,
          showNotificationPopup: false,
        });
        this.handleOnUpdateOrRestoreState(false, utilsService.getIsInWidget());
        this.props.clearAutomatedCallLoop();
      },
      popupAcceptBtnText: null,
      popupRejectBtnText: null,
      popupCloseBtnText: 'Cancel',
      showCloseIcon: false,
    });
  }
  render() {
    return (
      <>
        {(this.state.showNotificationPopup ||
          this.props.showNotificationPopupForWait) && (
          <NotificationComponent
            notificationTxt={this.state.notificationText}
            acceptBtnTxt={this.state.popupAcceptBtnText}
            acceptBtnFunc={this.state.popupAcceptBtnFunc}
            rejectBtnTxt={this.state.popupRejectBtnText}
            rejectBtnFunc={this.state.popupRejectBtnFunc}
            closeBtnTxt={this.state.popupCloseBtnText}
            closeBtnFunc={
              this.state.popupCloseBtnFunc
                ? this.state.popupCloseBtnFunc
                : this.closePopups
            }
            showCloseIcon={this.state.showCloseIcon}
          />
        )}
      </>
    );
  }
}

AutomatedCallAndBFI.contextType = AppContext;
export default AutomatedCallAndBFI;
